import i18next from 'i18next';
import translationsFi from '@/Fi16100/Translations/fi.json';

export function initI18next(locale) {
	i18next.init({
		lng: locale ?? 'fi',
		ns: ['fi16100'],
		defaultNS: 'fi16100',
		resources: {
			fi: {
				fi16100: translationsFi,
			}
		}
	});

	return i18next;
}
